var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShieldLock1 = function SvgShieldLock1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.467,
    d: "m17.694 10.15-1.61-1.62-4.501-4.535-3.416-.504L3.5 2.805v7.072q-.002 4.406 2.287 9.333 2.284 4.93 5.796 7.971 2.534.732 4.428-.259a5.6 5.6 0 0 0 1.368-1.017q.351-.352.644-.752 1.643-2.211 1.642-5.943v-7.072zm-3.08 11.825-1.881-1.087-4.181-2.413v-5.798l.41.236.6.347v-1.157q0-.96.593-1.295.594-.34 1.428.142.305.176.578.427.198.179.376.395a5 5 0 0 1 .681 1.082q.385.813.385 1.582v1.158l1.01.583z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.467,
    d: "M13.603 14.436v.07l-.385.191-.625.313v-1.157q0-.494-.29-.994a2 2 0 0 0-.597-.67q-.06-.042-.123-.08-.389-.223-.663-.111l1.241-.621q.198.178.376.394a5 5 0 0 1 .681 1.083q.385.812.385 1.582"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.467,
    d: "m12.161 11.378-1.241.62-.058.029q-.29.167-.29.66v.07l-1.01.504v-1.157q0-.96.593-1.295.594-.34 1.428.142.305.175.578.427"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.467,
    d: "M12.593 13.853v1.158l-2.02-1.167v-1.157q-.001-.494.289-.66l.058-.029q.275-.111.663.112.064.038.123.08.35.239.598.67.29.5.289.993M14.614 16.947v5.028l-1.881-1.087-4.181-2.413 4.666-2.333z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#262626",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.467,
    d: "M13.218 14.698v1.445l-4.666 2.333v-5.798l.41.235.6.348 1.01-.504v1.087l2.02 1.167zM24.332 9.805v7.072q.002 4.406-2.287 6.694a5.5 5.5 0 0 1-1.55 1.109l-4.484 2.242a5.6 5.6 0 0 0 1.368-1.017q.351-.352.644-.752 1.643-2.211 1.642-5.943v-7.072zM24.332 9.804l-4.667 2.334-1.971-1.988-1.61-1.62-4.501-4.536 4.666-2.333zM16.25 1.66l-4.667 2.334-3.416-.504L3.5 2.804 8.167.471z"
  })));
};
export default SvgShieldLock1;